<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
    <!-- For App Update Modal -->
    <v-dialog width="500px" :value="updateExists" :timeout="0" transition="scale-transition">
      <v-card height="200px">
        <div class="update-modal">
          <div class="update-title-container">
            <h2 class="update-title">A new version is available! <br></h2>
            Click below to refresh.
          </div>
          <div class="update-btn-container">
            <v-btn @click="refreshApp" color="#18c684" width="150px">
              <strong>Update App</strong>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- End App Update Modal -->
  </v-app>
</template>

<script>
import update from "./mixins/update";
export default {
  name: 'App',
  data: () => ({
    //
  }),
  mixins: [ update ]
};
</script>
<style>
  .u-cont{
      font-family: 'Varela Round', sans-serif;
  }
  .val-header{
    font-family: 'Varela Round', sans-serif;;
    font-size: 56px;
    font-weight: 400;
  }
  .neu-btn{
    border-radius: 50px;
    background: #f39200;
    box-shadow:  16px 16px 32px #cf7c00, 
             -16px -16px 32px #ffa800;
  }
  .v-btn {
    text-transform:none !important;
  }
  body {
    background: white;
  }
  
  /* Update modal styles */
  .update-modal {
    height: 100%;
    margin: 0 3%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .update-title-container {
    text-align: center;
  }
  .update-title {
    font-family: 'Lato', sans-serif;
  }
  .update-btn-container {
    display: flex;
    width: 100%;
    justify-content: center;
    font-family: 'Lato', sans-serif;
  }
</style>